import { userRoles } from 'utils/constants';

export const getPropertyVehicles = (
    vg,
    activeOrg,
    propertyId,
    allowedRoles = [userRoles.RESIDENT, userRoles.TENANT]
) => {
    if (!activeOrg) {
        return [];
    }

    return (
        vg.members
            ?.filter(member =>
                allowedRoles.includes(member.properties?.[propertyId]?.role)
            )
            .flatMap(member =>
                (member.vehicles || []).map(vehicle => ({ ...vehicle, ownerId: member.uid }))
            ) || []
    );
};

export const getOrgVehiclePlates = manager => {
    return (
        manager.communityMembers?.map(member => Object.keys(member.plates || {})) || []
    ).flat();
};
